import { booleanAttribute, Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-toggle',
    templateUrl: './toggle.component.html',
    styleUrls: ['./toggle.component.scss']
})
export class ToggleComponent implements OnInit, OnChanges, OnDestroy {
    @Input()
    toggleState: string;

    @Input({ required: true })
    toggleOffLabel: string;

    @Input({ required: true })
    toggleOnLabel: string;

    @Input({ transform: booleanAttribute })
    disabled = true;

    @Output()
    toggled: EventEmitter<string> = new EventEmitter();

    toggleInput = new FormControl({ value: false, disabled: this.disabled });
    toggleHandleText: string;
    toggleLabelClass: string;

    private readonly _subscriptions = new Subscription();
    private readonly toggleOnStates = ['required'];

    ngOnInit(): void {
        this.setToggleDetails(this.toggleState);

        this._subscriptions.add(
            this.toggleInput.valueChanges.subscribe(value => {
                const toggleState = value ? this.toggleOnLabel : this.toggleOffLabel;
                this.setToggleDetails(toggleState);
                this.toggled.emit(toggleState);
            })
        );
    }

    ngOnChanges(changes: SimpleChanges): void {
        if ('disabled' in changes) {
            this.setToggleInputState(changes['disabled'].currentValue);
        }

        if ('toggleState' in changes) {
            this.toggleInput.setValue(
                [...this.toggleOnStates, this.toggleOnLabel.toLowerCase()].includes(changes.toggleState.currentValue?.toLowerCase())
            );
            this.setToggleDetails(changes.toggleState.currentValue);
        }
    }

    ngOnDestroy(): void {
        this._subscriptions.unsubscribe();
    }

    private setToggleInputState(isDiabled: boolean): void {
        if (isDiabled) {
            this.toggleInput.disable({ emitEvent: false });
        } else {
            this.toggleInput.enable({ emitEvent: false });
        }
    }

    private setToggleDetails(toggledLabel: string): void {
        this.toggleState = toggledLabel;
        if (!this.toggleState) {
            this.toggleState = this.toggleOffLabel;
        }
        this.toggleLabelClass = this.getToggleLabelCssClass(this.toggleState, this.disabled);
        this.toggleHandleText = this.toggleState?.toLowerCase() === 'required' ? '!' : '';
    }

    private getToggleLabelCssClass(toggleState: string, disabled: boolean): string {
        let cssClass = '';
        switch (toggleState?.toLowerCase()) {
            case 'required':
                cssClass = 'required';
                break;
            case 'yes':
                cssClass = 'toggle-checked';
                break;
            case 'no':
                cssClass = 'toggle-unchecked';
                break;
            default:
                throw new Error(
                    `Css class for ${toggleState} cannot be found. Please update mapping for Toggle state to toggle label css.`
                );
        }

        return this.toggleInput.disabled ? cssClass + ' disabled' : cssClass;
    }
}
